export default __webpack_public_path__ + "static/media/projectfirefly.e775ea6d.png";